import { useUtmContext } from 'marketing-tools';
import { getNextWhatsappPhone, sendWhatsappLead as sendToMktWeb } from "../services/MktWebService";
import useCookies from "./useCookies";
import usePageContext, { PageContext } from "./usePageContext";

export interface SendWhatsappLeadRequest {
    email: string,
    lgpd: boolean,
    name: string,
    phone: string
}

interface CampaignData {
    sellerName: string,
    tag: string,
    identify: string,
    consents: string[],
    googleReCaptchaToken: string,
    attendanceType: string,
    title: string,
    formType: string,
    campaignIdentfier: string
}

const plusCampaignData: CampaignData = {
    sellerName: 'Conquer Plus',
    tag: 'EDTECH_WHATSAPP_LEADS',
    identify: 'EDTECH_WHATSAPP_LEADS',
    consents: ['CCC'],
    googleReCaptchaToken: 'scaped',
    attendanceType: '',
    title: '',
    formType: 'b2c-whatsapp',
    campaignIdentfier: 'edtech-whatsapp-leads'
}

const posCampaignData: CampaignData = {
    sellerName: 'Conquer',
    tag: 'POS_WHATSAPP_LEADS',
    identify: 'POS_WHATSAPP_LEADS',
    consents: ['CCC'],
    googleReCaptchaToken: 'scaped',
    attendanceType: '',
    title: '',
    formType: 'b2c-whatsapp',
    campaignIdentfier: 'pos-whatsapp-leads'
}

const elProfessorCampaignData: CampaignData = {
    sellerName: 'Conquer',
    tag: 'ELPROFESSOR_WHATSAPP',
    identify: 'ELPROFESSOR_WHATSAPP',
    consents: ['CCC'],
    googleReCaptchaToken: 'scaped',
    attendanceType: '',
    title: '',
    formType: '',
    campaignIdentfier: ''
}

const unnaCampaignData: CampaignData = {
    sellerName: 'unna',
    tag: 'UNNA_WHATSAPP_LEADS',
    identify: 'UNNA_WHATSAPP_LEADS',
    consents: ['CCC'],
    googleReCaptchaToken: 'scaped',
    attendanceType: '',
    title: '',
    formType: 'b2c-whatsapp',
    campaignIdentfier: 'unna-whatsapp-leads'
}

const wolCampaignData: CampaignData = {
    sellerName: 'Wise Up Online',
    tag: 'WOL_WHATSAPP_LEADS',
    identify: 'WOL_WHATSAPP_LEADS',
    consents: ['WUCC'],
    googleReCaptchaToken: 'scaped',
    attendanceType: 'ONLINE',
    title: 'Wise Up - FAQ Online',
    formType: 'wiseup-whatsapp',
    campaignIdentfier: 'wol-whatsapp-leads'
}

export default function useMktWeb() {

    const { clientId } = useCookies();
    const { context } = usePageContext();
    const { utm } = useUtmContext();
    const campaignData = (() => {
        switch (context) {
            case PageContext.CONQUER_POS :
                return posCampaignData;
            case PageContext.EL_PROFESSOR:
                return elProfessorCampaignData;
            case PageContext.UNNA:
                return unnaCampaignData;
            case PageContext.WOL:
                return wolCampaignData;
            default:
                return plusCampaignData;
        }
    })();    

    const sendWhatsappLead = async (request: SendWhatsappLeadRequest, phone: string): Promise<string> => {
        const response = await sendToMktWeb({
            name: request.name,
            email: request.email,
            phone: request.phone,
            consents: campaignData.consents,
            ...utm,
            pageUrl: window.location.host,
            googleReCaptchaToken: "scaped",
            sellerName: campaignData.sellerName,
            title: document.title,
            attendanceType: campaignData.attendanceType
        }, campaignData.formType + "/" + campaignData.campaignIdentfier);
        return response.payload || phone;
    }

    const getNextWhatsapp = async (phone: string): Promise<string> => {
        const response = await getNextWhatsappPhone({
            name: "",
            email: "",
            phone: "",
            consents: [""],
            ...utm,
            pageUrl: window.location.host,
            googleReCaptchaToken: campaignData.googleReCaptchaToken,
            sellerName: campaignData.sellerName,
            title: document.title,
            attendanceType: campaignData.attendanceType,
            clientId: clientId

        });
        return response.payload || phone;
    }

    return { sendWhatsappLead, getNextWhatsapp };
}